//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gameCont from '../game/index.vue'
// import GNotice from "@/common/components/g-notice/"
import homeDialog from './components/home-dialog.vue'
import HomeXDialog from './components/home-x-dialog.vue'
import ContactUs from './components/contact.vue'
import PNotice from './components/p-notice/'
import { homeTabOptions, resetTextBylangKey } from '../../libs/options.js'
import { mapState, mapMutations } from 'vuex'
import {
    commonApi,
  } from "@/common/index";
export default {
    name: "Home",
    components: { homeDialog, HomeXDialog, gameCont, PNotice, ContactUs },
    data() {
        return {
            gameTypeCode: '3',
            tabIndex:0,
            tabOptions: [],
            include: [],
            isHide: true,
            homePendant: null, //首页挂件
            qMenuStyle: {},
        }
    },
    computed: {
        ...mapState({
            FrontConfigList: state => state.FrontConfigList,
            eventBanner: state => state.eventBanner,
            isLogin: state => state.isLogin,
        })
    },
    watch:{
        FrontConfigList(newVal, oldVal) {
            if (newVal.enableLottery) {
                this.setTabList(newVal)
                this.reJump()
                if (this.tabIndex > 3) {
                    setTimeout(()=>{
                        document.querySelector('.vux-tab').scrollLeft += this.tabIndex * 60;
                    }, 300)
                }
            }
        },
        eventBanner(newVal, oldVal) {
            if (newVal > 0) {
                setTimeout(()=>{
                    this.reJump();
                }, 600)
            }
        },
        // $route: {
        //   handler(v) {
        //     this.reJump();
        //   },
        //   deep: true
        // }
    },
    created() {
        this.qMenuStyle = {
          top: `calc(${window.innerHeight + 'px'} - 14.7rem)`
        }
        if (this.FrontConfigList && this.FrontConfigList.enableLottery) {
            // this.tabOptions = resetTextBylangKey(homeTabOptions, this.$t('home').tabOptions)
            this.setTabList(this.FrontConfigList)
            this.reJump()
            if (this.tabIndex > 3) {
                setTimeout(()=>{
                    document.querySelector('.vux-tab').scrollLeft += this.tabIndex * 60;
                }, 300)
            }
        }
        this._getH5();
    },
    methods: {
        ...mapMutations(["SET_NAV_LIST", "SET_COLOR_DOWNLOADSHOW", 'SET_LOGIN_SHOW', "set_bottom"]),
        _getH5() { // 获取H5挂件信息
            commonApi.HOMEBEFORE.getHomePendant('h5HomePendant').then((data) => {
                this.homePendant = data;
            })
        },
        setTabList(newVal) {
            let list = resetTextBylangKey(homeTabOptions, this.$t('home').tabOptions)
            if (newVal.enableLottery == 0) {
                list = list.filter((item)=>{
                    return item.langKey != 'Lottery'
                })
            }
            if (newVal.enableFish == 0) {
                list = list.filter((item)=>{
                    return item.langKey != 'Fish'
                })
            }
            this.tabOptions = list
        },
        reJump() {
            // 注册
            if (window.location.href.indexOf('path=signup') !=-1 ) {
                this.$router.push({path: '/signup', replace: true})
                return
            }

            // 捕鱼
            if (window.location.href.indexOf('path=fish') !=-1 ) {
                if (this.$store.state.FrontConfigList.enableFish == 1) {
                    this.$router.push({path: '/gamelobby/fish', replace: true})
                } else {
                    this.$router.push({path: '/', replace: true})
                }
                return
            }

            if (this.$route.path === '/gamelobby/fish') {
                this.tabIndex = 3
                this.gameTypeCode = 5
            }

            if (this.$route.path === '/gamelobby/sports' || this.$route.path === '/') {
                this.tabIndex = 0
                this.gameTypeCode = 3
            }

            // lottery
            if (window.location.href.indexOf('path=lottery') !=-1 ) {
                if (this.$store.state.FrontConfigList.enableLottery == 1) {
                    this.$router.push({path: '/gamelobby/lottery', replace: true})
                } else {
                    this.$router.push({path: '/', replace: true})
                }
                return
            }

            if (this.$route.path === '/gamelobby/lottery') {
                this.tabIndex = 5
                this.gameTypeCode = 4
            }

            // LIVE
            if (window.location.href.indexOf('path=live') !=-1 ) {
                this.$router.push({path: '/gamelobby/live', replace: true})
            }
            if (this.$route.path === '/gamelobby/live') {
                this.tabIndex = 2
                this.gameTypeCode = 2
            }

            // chess
            if (window.location.href.indexOf('path=chess') !=-1 ) {
                this.$router.push({path: '/gamelobby/chess', replace: true})
                return
            }
            if (this.$route.path === '/gamelobby/chess') {
                this.tabIndex = 3
                this.gameTypeCode = 6
            }

            // promotions
            if (window.location.href.indexOf('path=promotions') !=-1 ) {
                this.$router.push({path: '/promotions', replace: true})
                return 
            }

            // slot
            if (window.location.href.indexOf('path=egame') !=-1 ) {
                this.$router.push({path: '/gamelobby/egame', replace: true})
                return
            }

            if (this.$route.path === '/gamelobby/egame') {
                this.tabIndex = 4
                this.gameTypeCode = 1
            }

            if (this.$route.path === '/gamelobby/crash') {
                this.tabIndex = 1
                this.gameTypeCode = 7
            }
            // this.handleClick({
            //     tabIndex: this.tabIndex
            // })
            
            this.$store.commit('setEventBanner', 0)
        },
        handleClick({ tabIndex }) { // 导航点击
            const { gameId, langKey, path } = this.tabOptions[tabIndex]
            if (gameId) {
                this.tabIndex = tabIndex
                this.gameTypeCode = gameId
                if (path) {
                    this.$router.push({ path })
                }
            } else {
                if (langKey === 'IPL') {
                    // window.open('https://iplsite.com/')
                    console.log(this.$store.state.FrontConfigList.IPL)
                    window.open(this.$store.state.FrontConfigList.IPL)
                }
                if (langKey === 'Mobile'){
                    // window.open(this.$store.state.linkList.appDownload)
                    // window.open('https://app.ekbet.com/ekbet/')
                    this.$router.push({ path: '/ekbet' })
                }
                if (langKey === 'Reward'){
                    this.$router.push({ path: '/red-envelope' })
                }
                if (langKey === 'Affiliate' || langKey === 'InviteFriends'){
                    
                    this.$router.push({ path })
                    // this.$router.push({ path: '/affiliate' })
                    // this.$router.push({ path: '/agency' })
                }
            }
        },
        handleH5({ imgClickLink }) { // 点击H5挂件操作
            if (imgClickLink === '') return
            if (imgClickLink.indexOf('http') === -1) {
                // if (this.isLogin) {
                //     this.$router.push({ path: imgClickLink.replace('#', '') })
                // } else {
                //     this.$router.push({ path: '/login' })
                // }
                this.$router.push({ path: imgClickLink.replace('#', '') })
            } else {
                window.open(imgClickLink)
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/pages/build821/views/home/index.vue